import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowRight, EnvelopeSimple, ArrowLeft } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch (_) {
      // toujours générique — pas de fuite d'information
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-background text-left">
      <div className="hidden md:flex flex-col justify-between bg-[#0a0a0a] text-white p-12 relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.06]"
          style={{ backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)", backgroundSize: "42px 42px" }} />
        <div className="absolute -top-24 -right-24 h-80 w-80 rounded-full blur-3xl opacity-30"
          style={{ background: "radial-gradient(circle, #FF6B35, transparent 70%)" }} />
        <div className="relative"><img src="/innova-fact-white.png" alt="innova-fact" className="h-14 w-auto" /></div>
        <div className="relative">
          <h1 className="font-heading text-4xl lg:text-5xl font-bold tracking-tighter leading-none">
            Mot de passe<br /><span className="text-primary">oublié ?</span>
          </h1>
          <p className="mt-6 text-white/70 max-w-sm leading-relaxed">Pas de souci — nous vous enverrons un lien sécurisé pour en choisir un nouveau.</p>
        </div>
        <div className="relative text-xs text-white/50 tracking-wider uppercase">Portail sécurisé</div>
      </div>

      <div className="flex items-center justify-center p-6 md:p-12">
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} className="w-full max-w-sm">
          <div className="md:hidden flex items-center gap-2 mb-8"><img src="/innova-fact-dark.png" alt="innova-fact" className="h-9 w-auto" /></div>

          {sent ? (
            <div data-testid="forgot-sent" className="space-y-4">
              <div className="h-11 w-11 rounded-sm bg-emerald-50 border border-emerald-200 flex items-center justify-center"><EnvelopeSimple size={22} className="text-emerald-700" /></div>
              <h2 className="font-heading text-2xl font-bold tracking-tight">Vérifiez vos courriels</h2>
              <p className="text-sm text-muted-foreground">Si un compte admissible correspond à ce courriel, un lien de réinitialisation vous a été envoyé. Le lien est valide 1 heure.</p>
              <Button variant="outline" className="rounded-sm" onClick={() => navigate("/login")}><ArrowLeft size={16} className="mr-2" /> Retour à la connexion</Button>
            </div>
          ) : (
            <>
              <h2 className="font-heading text-2xl font-bold tracking-tight">Réinitialiser le mot de passe</h2>
              <p className="text-sm text-muted-foreground mt-1 mb-8">Entrez le courriel de votre compte portail.</p>
              <form onSubmit={submit} className="space-y-4">
                <div className="space-y-1.5">
                  <Label htmlFor="email" className="text-xs uppercase tracking-[0.15em] text-muted-foreground">Courriel</Label>
                  <Input id="email" data-testid="forgot-email" type="email" required className="rounded-sm h-11" placeholder="vous@entreprise.ca" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <Button type="submit" data-testid="forgot-submit" disabled={loading} className="w-full h-11 rounded-sm group">
                  {loading ? "Envoi…" : "Envoyer le lien"}
                  <ArrowRight size={18} className="ml-2 transition-transform group-hover:translate-x-1" />
                </Button>
                <button type="button" data-testid="forgot-back" onClick={() => navigate("/login")} className="text-xs text-muted-foreground hover:text-foreground flex items-center gap-1"><ArrowLeft size={14} /> Retour à la connexion</button>
              </form>
            </>
          )}
        </motion.div>
      </div>
    </div>
  );
}
